export interface GetRoleListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetRoleListPagingAndFilterResponseData
}

export interface GetRoleListPagingAndFilterResponseData {
    items: GetRoleListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetRoleListPagingAndFilterResponseItem {
    roleId: string
    name: string
    companyId: string
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export const initialGetRoleListPagingAndFilterResponseData: GetRoleListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}